export default __webpack_public_path__ + "static/media/advertising3.f3611c82.svg";